import PropTypes from "prop-types";
import React from "react";
import { FormattedMessage } from "react-intl";

export const SmallScreenExpand = ({ children, id = "expand-content" }) => (
    <div className="relative">
      <input type="checkbox" id={id} className="hidden peer" />
      <span className="md:h-fit md:space-y-2 flex flex-col mt-2 h-20 overflow-hidden peer-checked:h-fit peer-checked:space-y-2">
        {children}
      </span>
      <label htmlFor={id} className="absolute left-0 right-0 bottom-0 z-10 md:hidden flex peer-checked:hidden">
          <div className="min-h-14 w-full bg-gradient-to-b from-transparent via-white to-white px-4 pt-8 cursor-pointer text-center text-blue-600 hover:text-blue-700">
            <FormattedMessage id="expandContentLinkShow" defaultMessage="Show more..." description="Text for a link that expands to show more content" />
          </div>
      </label>
      <label htmlFor={id} className="mt-2 cursor-pointer text-center text-blue-600 hover:text-blue-700 hidden peer-checked:block"> 
        <FormattedMessage id="expandContentLinkHide" defaultMessage="Hide" description="Text for a link that hides expanded content" />
      </label>
    </div>
  );

  SmallScreenExpand.propTypes = {
    children: PropTypes.node,
    id: PropTypes.string,
  };